module.exports = __webpack_public_path__ + "img/bottom-arrow.d1ee63e5.svg";